<template>
  <div class="bannerskip-container">
    <el-select
      ref="select"
      v-model="value"
      placeholder="可导入总部品牌活动，可输入关键字搜索"
      filterable
      clearable
      prefix-icon="el-icon-search"
      :filter-method="searchCourse"
      :disabled="disabled"
      :style="tcfstyle"
      @clear="clearSelect"
    >
      <el-option :value="value" :label="changeLabel" style="height: auto;padding: 0;">
        <el-table
          :data="tableData"
          :show-header="false"
          style="width: 100%"
          @row-click="openDetails"
        >
          <el-table-column
            label="活动名称"
            min-width="500"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px;font-weight: normal">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-option>
      <el-pagination
        v-if="total>0"
        style="padding:10px"
        background
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </el-select>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getBrandOfflineList } from '@/api/pub'

export default {
  name: 'BrandOfflineSelect',
  props: {
    bid: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tcfstyle: {
      type: String,
      default: 'width: 100%'
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      filterText: '',
      value: '',
      changeLabel: '',
      brandid: 0
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.brandid = this.bid
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        bid: this.brandid,
        mark: 1,
        search: this.filterText
      }
      getBrandOfflineList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    clearSelect() {
      this.filterText = ''
      this.value = ''
      this.changeLabel = ''
      this.$emit('input', null)
    },
    searchCourse(val) {
      this.filterText = val
      this.getData()
    },
    openDetails(data) {
      this.value = data
      this.changeLabel = data.name
      this.$emit('input', data)
      // this.$emit('setCourse', data)
      this.$refs.select.blur()
    }
  }
}
</script>

<style scoped>

</style>
